import { useCardContext } from '../context/card-context';
import { CardFaceTypes } from '../global-types/card-face';

export const useActiveCardFace = () => {
  const {
    cardState: { cardFacesList, activeCardIndex },
  } = useCardContext();
  const face = cardFacesList[`${activeCardIndex}`];
  let isFront;

  if (face) {
    isFront = face.type === CardFaceTypes.FACEFRONT;
  }

  return { face, isFront };
};
